module.exports = __webpack_public_path__ + "img/Winner-9.df507c80.jpg";